module.exports = __webpack_public_path__ + "assets/img/3007.3de27a4d.svg";